import type { Icon } from '../../../src/lib/types'
export const mdiGroup: Icon = {
  "id": "group",
  "name": "Group",
  "path": "M1,1V5H2V19H1V23H5V22H19V23H23V19H22V5H23V1H19V2H5V1M5,4H19V5H20V19H19V20H5V19H4V5H5M6,6V14H9V18H18V9H14V6M8,8H12V12H8M14,11H16V16H11V14H14",
  "as": [],
  "tags": []
}
export default mdiGroup